<template>
    <div class="app">
        <div class="players">
            <div v-for="(player, i) in players" :key="i"
                 class="player-box"
                 :class="{current: player === currentPlayer}"
            >
                <div class="player-header">
                    <div class="player-name">
                        Игрок {{ i + 1 }}
                    </div>

                    <div class="player-coins">
                        <v-icon class="coin">mdi-circle-multiple-outline</v-icon>
                        <span>{{ player.coins }}</span>
                    </div>
                </div>
                <div class="player-footer">
                    <div class="player-max-score">
                        <span class="muted">Макс</span>
                        <div class="separator"></div>
                        <v-icon class="coin">mdi-chevron-triple-up</v-icon>
                        <span>{{ player.maxStreak }}</span>
                    </div>

                    <div class="player-total-coins">
                        <span class="muted">Всего</span>
                        <div class="separator"></div>
                        <v-icon class="coin">mdi-circle-multiple-outline</v-icon>
                        <span>{{ player.coinsEarned }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="score-bar">
            <v-btn
                style="background-color: #6d5abd;"
                fab dark x-large
                :disabled="!currentPlayer.coins"
                @click="spendCoin"
                class="smaller"
            >
                <v-icon>mdi-minus-circle-multiple-outline</v-icon>
            </v-btn>
            <v-btn @click="fail" fab dark x-large style="background-color: #dd4949;">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <div class="central">
                <div class="streak-wrap">
                    <div class="streak">
                        <v-icon class="coin">mdi-chevron-triple-up</v-icon>
                        <span>{{ streak + 1 }}</span>
                    </div>
                </div>
                <div class="value" :class="{'coin-bar': isCoinBar}">{{ scoreBar }}</div>
            </div>
            <v-btn @click="success" fab dark x-large style="background-color: #32cb5f;">
                <v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn @click="earnCoin" fab dark x-large style="background-color: #e9b93a;" class="smaller">
                <v-icon>mdi-plus-circle-multiple-outline</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import '@/assets/app.css'

const baseScoreBar = 1800
const scoreBarStep = 200
const coinScoreBar = 3000

interface Player {
    coins: number
    coinsEarned: number
    maxStreak: number
}

function createPlayer(): Player {
    return {
        coins: 0,
        coinsEarned: 0,
        maxStreak: 0,
    }
}

@Component({
    components: {
    },
})
export default class App extends Vue {
    players: Player[] = []
    currentPlayerIdx = 0
    playersCount = 2

    scoreBar = 0
    streak = 0

    created() {
        this.init()
    }

    init() {
        this.players = Array.from({length: this.playersCount}, createPlayer)
        this.currentPlayerIdx = 0
        this._resetBar()
    }

    _addCoin() {
        this.currentPlayer.coins++
        this.currentPlayer.coinsEarned++
    }

    _removeCoin() {
        this.currentPlayer.coins--
    }

    _raiseBar() {
        this.streak++
        this.currentPlayer.maxStreak = Math.max(this.currentPlayer.maxStreak, this.streak)
        this.scoreBar += scoreBarStep
    }

    _resetBar() {
        this.streak = 0
        this.scoreBar = baseScoreBar
    }

    _nextPlayer() {
        this.currentPlayerIdx = (this.currentPlayerIdx + 1) % this.playersCount
    }

    success() {
        if (this.scoreBar >= coinScoreBar) {
            this._addCoin()
        }
        this._raiseBar()
    }

    fail() {
        this._resetBar()
        this._nextPlayer()
    }

    earnCoin() {
        this._addCoin()
        this._raiseBar()
    }

    spendCoin() {
        this._removeCoin()
        this._raiseBar()
    }

    get currentPlayer() {
        return this.players[this.currentPlayerIdx]
    }

    get isCoinBar() {
        return this.scoreBar >= coinScoreBar
    }
}
</script>
